module.exports = __webpack_public_path__ + "static/img/keepTip.d82ccf4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DiwaliFestival/keepTip.svg
// module id = 9fgc
// module chunks = 0